import styled, {css} from 'styled-components'
import {breakpoints} from '../../theme/config'

export const CategoryWrapper = styled.div`
  overflow-x: hidden;
  position: relative;
  
  &:before, &:after {
    display: none;
    content: '';
    position: absolute;
    top: 0;
    height: 56px;
    width: 20px;
    z-index: 2;
  }
  
  ${({leftGradient, theme}) => leftGradient && `
    &:before {
      display: block;
      left: 0;
      background: linear-gradient(to right, ${theme.colors.others.lowerBarGradientLeftColor}, transparent);
    }
  `}
  
  ${({rightGradient, theme}) => rightGradient && `
    &:after {
      display: block;
      right: 0;
      background: linear-gradient(to left, ${theme.colors.others.lowerBarGradientRightColor}, transparent);
    }
  `}
`

export const CategoryBar = styled.ul`
  display: flex;
  max-height: 56px;
  min-width: ${breakpoints.large};
  padding: 0 15px;
  margin: 0;
  list-style-type: none;
  background-color: ${props => props.theme.colors.others.lowerBar}
  background: ${props => props.theme.colors.others.lowerBarGradient}
`

export const EmptyNav = styled.div`
  display: block;
  height: 56px;
  width: 100%;
  background-color: ${props => props.theme.colors.others.lowerBar}
  background: ${props => props.theme.colors.others.lowerBarGradient}
`

export const CategoryItem = styled.li`
  flex-grow: 1;
  position: relative;
`

export const CategoryItemLink = styled.a`
  display: block;
  line-height: 56px;
  height: 56px;
  font-weight: bold;
  font-size: 14px;
  text-align: center;
  text-decoration: none;
  color: ${props => props.theme.colors.greyscale.white};
  
  &:hover, &:focus {
    cursor: pointer;
    background-color: ${props => props.theme.colors.others.lowerBarLinksHoverBackground};
    color: ${props => props.theme.colors.greyscale.white};
  }
  
  ${({hovered}) => (hovered ? css`

    cursor: pointer;
    background-color: ${props => props.theme.colors.others.lowerBarLinksHoverBackground};
   ` : '')}
`

export const CategoryItemButton = styled.button`
  position: absolute;
  top: 50%;
  right: 0;
  transform: translate(0, -50%);
  background-color: ${props => props.theme.colors.others.lowerBarLinksHoverBackground};
  border: none;
  padding: 0px;
  height: 18px;
  width: 18px;
  display: flex;
  align-items: flex-start;
  
  &:not(:focus) {
    position: absolute !important;
    width: 1px !important;
    height: 1px !important;
    padding: 0 !important;
    margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686
    overflow: hidden !important;
    clip: rect(0, 0, 0, 0) !important;
    white-space: nowrap !important;
    border: 0 !important;
  }
`

export const Navigation = styled.nav`
  position: relative;
`
